import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { HttpService } from "./../../services/http.service";
import { ToolsService } from "./../../services/tools.service";
import { AdministreDialogComponent } from "./administre-dialog";
import { ToastrService } from "./../../components/_toastr/toastr.service";
import { Administre } from "../../interfaces/Administre";

@Injectable({
  providedIn: "root",
})
export class AdministreDialogService {
  constructor(
    private _dialog: MatDialog,
    private _http: HttpService,
    private _tools: ToolsService,
    private _toastr: ToastrService
  ) {}

  openDialog(administre_ID: number, callBack: Function = () => {}): void {
    const dialogRef = this._dialog.open(AdministreDialogComponent, {
      width: "600px",
      data: administre_ID,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && callBack) {
        callBack();
      }
    });
  }

  get(administre_ID: number, callBack: Function): void {
    this._http.GET(
      "/api/administre/" + administre_ID,
      null,
      (result) => {
        if (result.isOk) {
          callBack(result.obj);
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  post(administre: Administre, callBack: Function): void {
    this._http.POST(
      "/api/administre",
      administre,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Compte administré enregistré avec succès",
            type: "success",
          });
          // Retourner l'objet mis à jour avec le nouvel ID si c'est une création
          if (result.obj && result.obj.session_ID) {
            callBack(result.obj);
          } else {
            callBack(administre);
          }
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }

  delete(administre_ID: number, callBack: Function): void {
    this._http.DELETE(
      "/api/administre/" + administre_ID,
      null,
      (result) => {
        if (result.isOk) {
          this._toastr.show({
            title: "Félicitation",
            message: "Compte administré supprimé avec succès",
            type: "success",
          });
          callBack();
        } else {
          this._toastr.show({
            title: "Erreur",
            message: result.message,
            type: "error",
          });
        }
      },
      (error) => {
        this._tools.showHttpError(error);
      }
    );
  }
}
